var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"id":"download-csv-btn","icon":"","x-large":"","color":(!_vm.errors) ? 'primary' : 'red'},on:{"click":_vm.downloadCsv}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("fas fa-file-csv")])],1)]}}])},[_vm._v(" Export to CSV ")])}
var staticRenderFns = []

export { render, staticRenderFns }